module.exports = __webpack_public_path__ + "img/DCIImg01.c0c5dc22.png";